export function getRangeIdsFromAnchor<T extends string | number>(
  idsInOrder: T[],
  previousId: T | undefined,
  currentId: T,
  excludedIds: Set<T>,
): T[] {
  if (previousId == null || previousId === currentId) return [];

  const currentIndex = idsInOrder.indexOf(currentId);
  const previousIndex = idsInOrder.indexOf(previousId);
  if (currentIndex === -1 || previousIndex === -1) return [];

  const start = Math.min(currentIndex, previousIndex);
  const end = Math.max(currentIndex, previousIndex);

  return idsInOrder.slice(start, end + 1).filter((id) => !excludedIds.has(id));
}

export function getNearestSelectedAnchorId<T extends string | number>(
  idsInOrder: T[],
  uncheckedId: T,
  selectedIds: T[],
): T | undefined {
  const uncheckedIndex = idsInOrder.indexOf(uncheckedId);
  if (uncheckedIndex === -1) return undefined;

  const selectedSet = new Set(selectedIds);

  for (let i = uncheckedIndex - 1; i >= 0; i--) {
    const id = idsInOrder[i];
    if (selectedSet.has(id)) return id;
  }

  for (let i = uncheckedIndex + 1; i < idsInOrder.length; i++) {
    const id = idsInOrder[i];
    if (selectedSet.has(id)) return id;
  }

  return undefined;
}
